var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-8"},[_vm._m(0),_c('div',[_c('DataTableTollsScale')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-4 mt-1 d-flex justify-start align-center"},[_c('img',{attrs:{"width":"25","src":require("../../../assets/images/menu-icons/NewspaperColor.png"),"alt":""}}),_c('span',{staticClass:"ml-2 font-weight-bold"},[_vm._v("ค่าผ่านท่า และค่าชั่ง")])])
}]

export { render, staticRenderFns }